import React from 'react';
import I18n from '@/modules/i18n';

interface BulkGradingButtonProps extends Omit<React.HTMLProps<HTMLButtonElement>, 'className' | 'onClick' | 'type'> {
  modalManager: {
    close: () => void;
    isOpen: boolean;
    open: () => void;
  };
}

const BulkGradingButton = ({ modalManager, ...rest }: BulkGradingButtonProps) => (
  <div className="tw-flex tw-justify-center tw-mt-5">
    <button className="btn btn--purple" type="button" onClick={modalManager.open} {...rest}>
      {I18n.t('bulk_grade')}
    </button>
  </div>
);

export default BulkGradingButton;
